// export const getUTMParams = () => {
//   if (typeof window === "undefined") {
//     return {
//       source: "direct",
//       medium: "website",
//       campaign: "unknown",
//     };
//   }

//   const params = new URLSearchParams(window.location.search);

//   return {
//     source: params.get("utm_source") || "direct",
//     medium: params.get("utm_medium") || "website",
//     campaign: params.get("utm_campaign") || "unknown",
//   };
// };

export function getUTMParams() {

  const urlParams = new URLSearchParams(window.location.search);
  const utmFields = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_adgroup', 'utm_term'];
  const result = {};

  utmFields.forEach((utm) => {
    const value = urlParams.get(utm);
    if (value) {
      const field = document.querySelector(`input[name="${utm}"]`);
      if (field) field.value = value;

      result[utm] = value;
    }
  });

  return result;
}